<div class="sheet-container">
  <div class="sheet-header">
    <h2>{{ title }}</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div #content class="sheet-content"></div>
</div>